import { render, staticRenderFns } from "./AddToCart.vue?vue&type=template&id=faa39ea2&scoped=true&"
import script from "./AddToCart.vue?vue&type=script&lang=js&"
export * from "./AddToCart.vue?vue&type=script&lang=js&"
import style0 from "./AddToCart.vue?vue&type=style&index=0&id=faa39ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa39ea2",
  null
  
)

export default component.exports